import React from 'react';
import axios from 'axios';

import tick from '../../../content/media-library/icons/yes.svg';
import cross from '../../../content/media-library/icons/no.svg';

export default class SortCodeChecker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortcode: '',
      data: null,
      error: false,
      errorMsg: '',
      disabled: true
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    let sortcode = event.target.value;
    if (sortcode.length === 6) {
      this.setState({
        error: false,
        disabled: false
      });
    } else {
      this.setState({
        error: true,
        errorMsg: 'Sort code must be 6 characters',
        disabled: true
      });
    }

    this.setState({
      sortcode,
      data: null
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      data: null
    });

    axios
      .get(`${window.starlingbank.getConfig('sortCodeChecker')}${this.state.sortcode}`)
      .then((res) => {
        this.setState({
          data: res.data,
          error: false
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 404) {
          this.setState({
            error: true,
            errorMsg: 'No results found'
          });
        } else if (error.response.status === 400) {
          this.setState({
            error: true,
            errorMsg: 'Please check that the sortcode you have entered is in the correct format'
          });
        } else {
          this.setState({
            error: true,
            errorMsg: 'Something went wrong, please try again'
          });
        }
      });
  };

  render() {
    const bankDetails = this.state.data;
    const address = bankDetails?.address;

    return (
      <div className="checker">
        <div className="checker__wrapper">
          <form className="checker__form" onSubmit={this.handleSubmit}>
            <input
              className="checker__input"
              type="number"
              placeholder="e.g. 608371"
              sortcode="sortcode"
              onChange={this.handleChange}
            />
            <button className="cta-button" type="submit" disabled={this.state.disabled}>
              Check
            </button>
          </form>
        </div>
        {bankDetails ? (
          <div className="checker__results">
            <h3>{bankDetails.bankName}</h3>
            <h4>
              Branch title: <span>{bankDetails.branchTitle}</span>
            </h4>
            <h4>
              Sort code: <span>{bankDetails.sortCode} </span>
            </h4>
            <h4>
              Telephone number: <span>{bankDetails.telephone}</span>
            </h4>
            {address && (
              <>
                <h4>Address:</h4>
                {Object.values(address)
                  .filter((line) => line)
                  .map((line) => (
                    <p key={line} className="checker__address">
                      {line}
                    </p>
                  ))}
              </>
            )}
            <div className="checker__images">
              <h4>
                BIC code:{' '}
                {bankDetails.bicCode ? (
                  <span>{bankDetails.bicCode}</span>
                ) : (
                  <img src={cross} alt="This bank does not accept international payments" />
                )}
              </h4>
              <h4>
                Bacs accepted:{' '}
                {bankDetails.bacsAccepted ? (
                  <img src={tick} alt="This bank accepts Bacs" />
                ) : (
                  <img src={cross} alt="This bank does not accept Bacs" />
                )}
              </h4>
              <h4>
                Faster Payments accepted:{' '}
                {bankDetails.fasterPaymentsAccepted ? (
                  <img src={tick} alt="This bank accepts Faster Payments" />
                ) : (
                  <img src={cross} alt="This bank does not accept Faster Payments" />
                )}
              </h4>
              <h4>
                Chaps accepted:{' '}
                {bankDetails.chapsAccepted ? (
                  <img src={tick} alt="This bank accepts Chaps Payments" />
                ) : (
                  <img src={cross} alt="This bank does not accept Chaps Payments" />
                )}
              </h4>
              <h4>
                Account switching:{' '}
                {bankDetails.accountSwitchingAvailable === 'FULL_AND_PARTIAL' ? (
                  <span>This bank supports full or partial switching</span>
                ) : bankDetails.accountSwitchingAvailable === 'PARTIAL' ? (
                  <span>This bank supports only partial switching</span>
                ) : (
                  <span>This bank does not support full or partial switching</span>
                )}
              </h4>
            </div>
          </div>
        ) : null}
        {this.state.error && <p>{this.state.errorMsg}</p>}
      </div>
    );
  }
}
